import { Component, OnInit } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import { firstValueFrom } from "rxjs";
import { ActivityLogService } from "src/app//shared-lib/domains/activity-log";
import { Order } from "src/app/models/models";
import { IncidenceService, IncidenceUI } from 'src/app/shared-lib/domains/incidence';
import { UserService } from "src/app/shared-lib/domains/user";
import { NotificationsService } from "src/app/shared/notifications.service";
import { OrderService } from "src/app/shared/order.service";

@Component({
  selector: "app-order-report-incident",
  templateUrl: "./order-report-incident.component.html",
  styleUrls: ["./order-report-incident.component.scss"],
  standalone: false
})
export class OrderReportIncidentComponent implements OnInit {
  order: Order;
  order_number: number;
  destination_emails: string[] = ['incidencias@copyfly.es'];
  user_name: string = "";
  user_email: string = "";
  text_indicent: string = "";
  toast_sent: string = "Incidencia enviada al departamento de Atención al Cliente de Copyfly";
  filePreview: string | ArrayBuffer | null = null;
  selectedFile: File | null = null;
  selectedFiles: File[] = [];
  filePreviews: { url: string, type: string, file: File; }[] = [];

  isSending = false;

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private userService: UserService,
    private notificationsService: NotificationsService,
    private orderService: OrderService,
    private activityLogService: ActivityLogService,
    private incidenceService: IncidenceService
  ) {
    this.order = this.navParams.data.info.order;
    this.order_number = this.navParams.data.info.order.number;
    this.user_name = `${this.userService.userG.firstName} ${this.userService.userG.lastName}`;
    this.user_email = this.userService.userG.email;
  }

  ngOnInit() { }

  public onCloseModal() {
    this.modalCtrl.dismiss();
  }

  public async onSendReport() {
    this.isSending = true;
    try {
      // Subir todos los archivos seleccionados y guardar sus URLs y tipos
      const attachments: { url: string; type: string; }[] = [];
      for (const preview of this.filePreviews) {
        const uploadResult = await firstValueFrom(
          this.incidenceService.uploadIncidenceFile(preview.file, this.order.id)
        );
        attachments.push({ url: uploadResult.storedFile.url, type: preview.type });
      }

      // Crear incidencia con todos los adjuntos
      const incidence: IncidenceUI = {
        order: { id: this.order.id, number: this.order_number },
        customerComment: this.text_indicent,
        status: 'reported',
        attachments
      };

      await this.incidenceService.createIncidence(incidence);

      // Acciones adicionales (movidas a onWriteIncidences en server)
      // this.markOrderAsReported();
      // this.sendReportToActivityLog(this.text_indicent);
      // this.sendReportEmail();
      this.modalCtrl.dismiss();
      this.notificationsService.showToast(this.toast_sent);
    } catch (e) {
      this.notificationsService.showToast('Error al enviar la incidencia');
    } finally {
      this.isSending = false;
    }
  }

  onFilesSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;

    // Convierte FileList a Array
    const newFiles = Array.from(input.files);

    // Inicializa filePreviews si no existe
    if (!this.filePreviews) {
      this.filePreviews = [];
    }

    // Calcula cuántos archivos se pueden añadir
    const currentCount = this.filePreviews.length;
    const maxAllowed = 5 - currentCount;

    if (maxAllowed <= 0) {
      // Muestra mensaje si ya tiene 5 archivos
      console.log('Ya has alcanzado el límite de 5 archivos');
      return;
    }

    // Toma solo los archivos que caben dentro del límite
    const filesToAdd = newFiles.slice(0, maxAllowed);

    // Procesa los nuevos archivos y añade a los existentes
    const previews = filesToAdd.map(file => ({
      url: URL.createObjectURL(file),
      type: file.type,
      file: file
    }));

    // Añade a los archivos existentes
    this.filePreviews = [...this.filePreviews, ...previews];

    // Limpia el input para permitir seleccionar el mismo archivo de nuevo
    input.value = '';
  }

  // Método para eliminar un archivo específico
  removeFile(index: number) {
    if (this.filePreviews && this.filePreviews[index]) {
      // Libera la memoria del objeto URL
      URL.revokeObjectURL(this.filePreviews[index].url as string);
      // Elimina el archivo del array
      this.filePreviews.splice(index, 1);
    }
  }

  isImage(type: string): boolean {
    return type.startsWith('image/');
  }

  isVideo(type: string): boolean {
    return type.startsWith('video/');
  }

}

